import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/auth";

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

const ClientAuthCtx = createContext(null);

export function ClientAuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = logged out, obj = user
  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/client/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(false);
      return false;
    }
  }, []);
  useEffect(() => {
    refresh();
  }, [refresh]);
  const logout = useCallback(async () => {
    await api.post("/client/auth/logout");
    setUser(false);
  }, []);
  return (
    <ClientAuthCtx.Provider value={{ user, setUser, refresh, logout }}>
      {children}
    </ClientAuthCtx.Provider>
  );
}

export const useClientAuth = () => useContext(ClientAuthCtx);

export function startClientGoogle() {
  const redirectUrl = window.location.origin + "/client-auth";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}
